import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, X } from 'lucide-react';
export function Audience() {
  return <section className="py-24 px-6 bg-teal text-cream" data-id="element-13">
      <div className="max-w-5xl mx-auto" data-id="element-14">
        <div className="grid md:grid-cols-2 gap-12" data-id="element-15">
          <FadeIn data-id="element-16">
            <div className="bg-white/5 p-8 md:p-10 rounded-2xl border border-white/10 h-full" data-id="element-17">
              <h3 className="text-2xl font-serif mb-8 text-white" data-id="element-18">
                Who This Is For
              </h3>
              <ul className="space-y-6" data-id="element-19">
                {['Women 40+ who are tired of waking up in damp sheets every single night.', 'Anyone experiencing "migrating" joint pain in their hands, hips, or knees.', 'Women who feel "puffy," inflamed, and exhausted from broken sleep.', 'Those who want a natural, food-based solution that works fast.'].map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-20">
                    <Check className="w-6 h-6 text-sage shrink-0 mt-1" data-id="element-21" />
                    <span className="text-lg text-cream/90" data-id="element-22">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-23">
            <div className="bg-black/20 p-8 md:p-10 rounded-2xl border border-black/10 h-full" data-id="element-24">
              <h3 className="text-2xl font-serif mb-8 text-white/80" data-id="element-25">
                Who This Is NOT For
              </h3>
              <ul className="space-y-6" data-id="element-26">
                {['People looking for a "magic pill" that requires zero change in habits.', 'Anyone not willing to commit to a focused 7-day nutritional window.', 'Those who prefer long-term medical treatments over immediate lifestyle resets.'].map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-27">
                    <X className="w-6 h-6 text-coral/80 shrink-0 mt-1" data-id="element-28" />
                    <span className="text-lg text-cream/70" data-id="element-29">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}